<template>
  <div id="home-new" >


    <el-row :gutter="20">
      <el-col :span="16">
        <el-card  class="header-data">
          <!--                <div  class="clearfix">-->
          <!--                    <span style="font-size: 24px;font-weight:bold">{{dataName.bedName}}</span>-->
          <!--                </div>-->
          <el-form  label-width="60px" size="small" style="margin-top: 20px;margin-left: -20px">
            <el-col :span="24">
              <el-row :gutter="24">
                <el-col :span="5">
                  <el-form-item label="姓名:">
                    <el-input v-model="agedHealthTable.condition.agedName" placeholder="请输入" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="证件号:">
                    <el-input v-model="agedHealthTable.condition.idCard" placeholder="请输入" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="地址:">
                    <el-input v-model="agedHealthTable.condition.location" placeholder="请输入" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-button size="small" @click="getAgedTable()" type="primary" >搜索</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="24">
            <el-container style="height: 560px" >
              <el-main class="main-new" >
                <el-row :gutter="20" >
                  <el-col :span="6" style="margin-bottom: 20px;margin-top: -10px" v-for="(item,id) in agedHealthTable.data" :key="id">
                    <el-card :span="24" class="card-1" shadow="hover" >
                      <el-row>
                        <el-col :span="3" style="margin-top: -25px;margin-left: -42px">
                          <div class="icon-1">
                            <img v-if="item.icon"
                                 :src="'/system-ya/file/image/'+item.icon"  width="60px" height="60px" >
                            <img v-else-if="item.agedSex == '男'"
                                 src="/static/asert/image/report/icon-2.1.png"  width="60px" height="60px" >
                            <img v-else-if="item.agedSex == '女'"
                                 src="/static/asert/image/report/icon-2.2.png"  width="60px" height="60px" >
                            <img v-else
                                 src="/static/asert/image/report/icon-2.1.png"  width="60px" height="60px" >
                          </div>
                        </el-col>
                        <el-col :span="3" style="margin-top: -15px;margin-left: 70px">
                          <div class="icon-1">
                            <!--                                                    <img src="../static/asert/image/report/icon-1.4.1.png">-->
                          </div>
                        </el-col>
                        <el-col :span="3" style="margin-top: -15px;margin-left: 10px">
                          <div class="icon-1">
                            <img :src=item.cDaiPage @click="ceshi(item.id)">
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="24">
                        <el-col :span="12" style="margin-top: 15px;margin-left: 5px;font-weight:bold;font-size: 14px;">
                          <a href="javascript:void(0);" @click="choice(item.id)">
                            <span style="font-weight:bold;color:#333333">{{item.agedName}}</span>
                          </a >

                        </el-col>
                        <el-col :span="8" style="margin-top: 15px;margin-left: -11px;font-size: 12px;font-weight:bold;color: #999999">
                          <div>性别</div>
                        </el-col>
                        <el-col :span="3" style="margin-top: 15px;margin-left: -25px;font-size: 12px;font-weight:bold">
                          <div>{{item.agedSex}}</div>
                        </el-col>
                      </el-row >
                      <el-row :gutter="24">
                        <el-col :span="9" style="margin-top: 24px;margin-left: 6px;font-size: 12px;font-weight:bold;color: #999999">
                          <div>电话</div>
                        </el-col>
                        <el-col :span="8" style="margin-top: 24px;margin-left: -36px;font-size: 12px;font-weight:bold">
                          <div>{{item.phone}}</div>
                        </el-col>
                      </el-row >
                      <el-row>
                        <el-col :span="3" style="margin-top: -2px;margin-left: -36px">
                          <div class="icon-1">
                            <img :src=item.page>
                          </div>
                        </el-col>
                        <el-col :span="14" style="margin-top: 29px;margin-left: 42px;font-size: 12px;font-weight:bold" >
                          <a href="javascript:void(0);" @click="GetGJXX(item.id)">
                            <span :style="{'color': item.color}">{{item.pageText}}</span>
                          </a >

                        </el-col>
                      </el-row>
                      <!--                                        <el-row>-->
                      <!--                                            <el-col :span="6" style="margin-top: 5px;margin-left: 5px;font-size: 12px;font-weight:bold;color: #999999">-->
                      <!--                                                <div>心率</div>-->
                      <!--                                            </el-col>-->
                      <!--                                            <el-col :span="6" style="margin-top: 5px;margin-left: -5px;font-size: 12px;font-weight:bold">-->
                      <!--                                                <div>空</div>-->
                      <!--                                            </el-col>-->
                      <!--                                            <el-col :span="6" style="margin-top: 5px;margin-left: 5px;font-size: 12px;font-weight:bold;color: #999999">-->
                      <!--                                                <div>呼吸</div>-->
                      <!--                                            </el-col>-->
                      <!--                                            <el-col :span="6" style="margin-top: 5px;margin-left: -5px;font-size: 12px;font-weight:bold">-->
                      <!--                                                <div>空</div>-->
                      <!--                                            </el-col>-->
                      <!--                                        </el-row>-->
                    </el-card>
                  </el-col>
                </el-row>

                <div class="pagination">
                  <el-pagination
                      @current-change="handleCurrentChange"
                      @size-change="agedHealthTable"
                      :current-page.sync="agedHealthTable.page.currentPage"
                      :page-sizes="[8, 40, 80]"
                      :page-size.sync="agedHealthTable.page.pageSize"
                      layout="sizes,  prev, pager, next, total"
                      :total="agedHealthTable.page.total">
                  </el-pagination>
                </div>
              </el-main>
            </el-container>
<!--            <el-container >-->
<!--              <main class="main-new1" >-->
<!--                <el-row>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceSOS" style="border-radius: 8px;margin-top: 15px;background-color: #FF3333;color: #FFFFFF">SOS告警 {{DataQtyOld.sos}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceSmoke" style="border-radius: 8px;margin-top: 15px;background-color: #E8523E;color: #FFFFFF">烟感告警 {{DataQtyOld.smoke}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceWATER" style="border-radius: 8px;margin-top: 15px;background-color: #5F43FF;color: #FFFFFF">水浸告警 {{DataQtyOld.water}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceInfrared" style="border-radius: 8px;margin-top: 15px;background-color: #F7A300;color: #FFFFFF">红外告警 {{DataQtyOld.infrared}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceDOOR" style="border-radius: 8px;margin-top: 15px;background-color: #2C70F7;color: #FFFFFF">门磁告警 {{DataQtyOld.door}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="choiceGAS" style="border-radius: 8px;margin-top: 15px;background-color: #A6B7D0;color: #FFFFFF">燃气告警 {{DataQtyOld.gas}}</el-button>-->
<!--                  </el-col>-->
<!--                  <el-col :span="3">-->
<!--                    <el-button size="small" @click="lodWoTab" style="border-radius: 8px;margin-top: 15px;background-color: #13BBFF;color: #FFFFFF">卧床告警 {{DataQtyOld.wuoC}}</el-button>-->
<!--                  </el-col>-->

<!--                </el-row>-->
<!--              </main>-->
<!--            </el-container>-->
          </el-col>
        </el-card>
      </el-col>




      <el-col :span="8">
        <el-card class="header-data-1">
          <div  class="clearfix">
            <span style="font-size: 18px;font-weight:bold">设备分析图</span>
          </div>
          <el-row>
            <el-col :span="5">
              <div id="data_2" style="width: 520%;height:300%;"></div>
            </el-col>
          </el-row>

        </el-card>
        <el-card class="header-data-1">
          <div  class="clearfix" style="margin-bottom:10px" >
            <span style="font-size: 18px;font-weight:bold" >实时告警列表</span>
          </div>
          <el-row>
            <el-col :span="24">
              <div style="height: 257px;overflow: auto">
                <el-timeline>
                  <template v-for="event in events">
                    <el-timeline-item :timestamp="event.createTime" placement="top"
                                      style="margin-left: 1%;height: 51px" color="#2C70F7" >
                      <a href="javascript:void(0);" @click="choice(event.agedId)">
                        <span style="font-weight:bold;color:#333333">{{event.content}}</span>
                      </a >
<!--                      <div>{{event.content}}</div>-->
                    </el-timeline-item>
                  </template>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog v-if="NBiotEventTableVisible" :title="NBiotEventTableTitle" :visible.sync="NBiotEventTableVisible" :close-on-click-modal="false" width="70%">
      <el-row :gutter="20" class="out-border">
        <el-col :span="24">
          <div class="page-content">
            <div>
              <el-table :data="NBiotEventTable.data" highlight-current-row>
                <el-table-column prop="agedName" label="告警老人"></el-table-column>
                <el-table-column prop="status" label="状态">
                  <template scope="scope">
                    <span v-if="scope.row.status==='报警'" style="color: green">已处理（报警）</span>
                    <span v-if="scope.row.status==='测试'" style="color: green">已处理（测试）</span>
                    <span v-if="scope.row.status==='误报'" style="color: green">已处理（误报）</span>
                    <span v-if="scope.row.status==='演练'" style="color: green">已处理（演练）</span>
                    <span v-if="scope.row.status==='告警'" style="color: red">发生告警</span>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="设备类型">
                  <template scope="scope">
                    <span v-if="scope.row.type==='SOS'" >SOS告警</span>
                    <span v-if="scope.row.type==='GAS'" >燃气告警</span>
                    <span v-if="scope.row.type==='WATER'" >水浸告警</span>
                    <span v-if="scope.row.type==='Smoke'" >烟雾告警</span>
                    <span v-if="scope.row.type==='Infrared'" >红外告警</span>
                    <span v-if="scope.row.type==='DOOR'" >门磁告警</span>
                  </template>
                </el-table-column>
                <el-table-column prop="textAged" label="处理人"></el-table-column>
                <el-table-column prop="createTime" label="告警时间"></el-table-column>
                <el-table-column prop="content" label="告警信息"></el-table-column>
                <el-table-column prop="textRead" label="处理方式"></el-table-column>
                <el-table-column prop="textText" label="处理结果"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope" >
                    <el-button size="mini" type="text" @click="handleNBiotEdit(scope.row.id)">处理</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                  @current-change="handleCurrentChange"
                  @size-change="NBiotEventTable"
                  :current-page.sync="NBiotEventTable.page.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size.sync="NBiotEventTable.page.pageSize"
                  layout="sizes,  prev, pager, next, total"
                  :total="NBiotEventTable.page.total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--    新增页面  编辑页面-->
    <el-dialog v-if="NBiotDialogVisible" :title="NBiotDialogTitle" :visible.sync="NBiotDialogVisible" :close-on-click-modal="false">
      <el-form :model="NBiotEventInfo" ref="NBiotForm"  size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="老人" prop="agedName" :label-width="lableWidth" >
              <el-input v-model="NBiotEventInfo.agedName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--            <el-row :gutter="20">-->
        <!--                <el-col :span="12">-->
        <!--                    <el-form-item label="imei号" prop="imei" :label-width="lableWidth">-->
        <!--                        <el-input v-model="NBiotEventInfo.imei" :disabled="true"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--            </el-row>-->
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="告警信息" prop="content" :label-width="lableWidth">
              <el-input v-model="NBiotEventInfo.content" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="告警处理" prop="status" :label-width="lableWidth">
              <el-select v-model="NBiotEventInfo.status" placeholder="请选择">
                <el-option label="误报" value="误报"></el-option>
                <el-option label="演练" value="演练"></el-option>
                <el-option label="测试" value="测试"></el-option>
                <el-option label="报警" value="报警"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理人" prop="text_aged" :label-width="lableWidth" >
              <el-input v-model="NBiotEventInfo.textAged" placeholder="请输入处理人"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="处理方式" :label-width="lableWidth">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入处理方式"
                  v-model="NBiotEventInfo.textRead">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="处理结果" :label-width="lableWidth">
              <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入处理结果"
                  v-model="NBiotEventInfo.textText">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="NBiotDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpd">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog v-if="reportDialog.visible" :title="reportDialog.title"
               :visible.sync="reportDialog.visible" top="3%"
               width="70%">
      <el-row :gutter="20">
        <el-col :span="24">
          <div style="text-align: center">
            <template  v-if="reportDialog.message">
              <el-divider>实时数据</el-divider>
              <el-row :gutter="20">
                <el-col :span="8">
                  <p>{{reportDialog.message.sn}}</p>
                  <p>设备号</p>
                </el-col>
                <el-col :span="8">
                  <p v-if="reportDialog.message.timestamp">{{reportDialog.message.timestamp}}</p>
                  <p>数据时间</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.heartRate}}</p>
                  <p>实时心率</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <p>{{reportDialog.message.breath}}</p>
                  <p>实时呼吸</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.status}}</p>
                  <p>实时状态</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.power}}</p>
                  <p>电量</p>
                </el-col>
              </el-row>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div style="text-align: center">
            <div>
              <el-divider>香睡指数</el-divider>
              <p style="font-size: 30px;font-weight: bold;line-height: 30px">{{reportDialog.data.score.d}}</p>
              <p style="font-size: 20px;line-height: 30px">{{reportDialog.data.score_desc}}</p>
            </div>
            <div style="margin-top: 50px">
              <el-divider>睡眠总时长</el-divider>
              <p style="font-size: 16px;line-height: 20px">{{reportDialog.data.total_duration.h}}小时{{reportDialog.data.total_duration.m}}分钟</p>
              <p style="font-size: 16px;line-height: 20px">{{reportDialog.data.gobed_time.d}} - {{reportDialog.data.outbed_time}}</p>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <el-divider>各项睡眠监测数据统计</el-divider>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.gobed_time.s">{{reportDialog.data.gobed_time.d}}</p>
              <p>上床时间</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.inbed_duration.s">{{reportDialog.data.inbed_duration.h}}小时{{reportDialog.data.inbed_duration.m}}分钟</p>
              <p>在床时间</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.deep_duration.s">{{reportDialog.data.deep_duration.h}}小时{{reportDialog.data.deep_duration.m}}分钟</p>
              <p>深睡时长</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.outbed_num.s">{{reportDialog.data.outbed_num.d}}次</p>
              <p>离床次数</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.move_num.s">{{reportDialog.data.move_num.d}}次</p>
              <p>体动次数</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.snoring_num.s">{{reportDialog.data.snoring_num.d}}次</p>
              <p>打鼾次数</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.avg_hx.s">{{reportDialog.data.avg_hx.d}}次/分</p>
              <p>平均呼吸率</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.avg_rh.s">{{reportDialog.data.avg_rh.d}}次/分</p>
              <p>平均心率</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.sleep_eff.s">{{reportDialog.data.sleep_eff.d}}</p>
              <p>睡眠效率</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-divider>呼吸(次/分)</el-divider>
          <div id="hx-bar" style="height: 300px"></div>
        </el-col>
        <el-col :span="12">
          <el-divider>心率(次/分)</el-divider>
          <div id="xl-line" style="height: 300px"></div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog v-if="HomeVisible" :title="HomeTitle" :visible.sync="HomeVisible" :close-on-click-modal="false" width="70%">
      <template>
        <el-tabs v-model="activeName" >
          <el-tab-pane label="老人档案" name="first">
            <div class="dialog-page" :style="{'height':($store.state.minPageHeight - 300) +'px'}">
              <el-scrollbar style="height: 100%">
                <div style="display: flex">
                  <div style="width: 120px">
                    <el-steps direction="vertical" :space="0" finish-status="success">
                      <el-step title="基本信息" status="process" style="min-height: 1100px"></el-step>
                      <el-step title="提交" status="success"></el-step>
                    </el-steps>
                  </div>
                  <div style="width: 100%;padding: 20px">
                    <el-row style="padding-top: 30px">
                      <el-col :span="24">
                        <el-form ref="aged-form" :model="agedDialog.form" :rules="agedDialog.rules"
                                 label-width="120px"
                                 size="small">
                          <div>
                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="姓名" prop="agedName">
                                  <el-input v-model="agedDialog.form.agedName"
                                            placeholder="请输入姓名"></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="性别">
                                  <el-radio v-model="agedDialog.form.agedSex" :label="1">男</el-radio>
                                  <el-radio v-model="agedDialog.form.agedSex" :label="0">女</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="证件号" prop="idCard">
                                  <el-input v-model="agedDialog.form.idCard"
                                            placeholder="请输入证件号"></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="证件类型">
                                  <el-select v-model="agedDialog.form.cardType" placeholder="请选择证件类型">
                                    <el-option label="身份证" value="ID_CARD"></el-option>
                                    <el-option label="驾驶证" value="DRIVER_LICENSE"></el-option>
                                    <el-option label="护照" value="PASS_PORT"></el-option>
                                    <el-option label="临时" value="TEMPORARY"></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">

                              <el-col :span="12">
                                <el-form-item label="联系电话" prop="phone">
                                  <el-input v-model="agedDialog.form.phone"
                                            placeholder="请输入联系电话"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>


                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="本市户籍">
                                  <el-select v-model="agedDialog.form.isLocal"
                                             placeholder="请选择是否本地户籍">
                                    <el-option label="是" :value="true"></el-option>
                                    <el-option label="否" :value="false"></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>

                            </el-row>


                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="类别">
                                  <el-row>
                                    <el-col :span="24">
                                      <el-select v-model="agedDialog.form.agedType" filterable
                                                 placeholder="请选择长者类型">
                                        <el-option
                                            v-for="item in agedTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                  </el-row>
                                </el-form-item>
                              </el-col>

                            </el-row>
                            <el-row :gutter="20">
                              <el-col :span="8">
                                <el-form-item label="服务地址" prop="province" >
                                  <el-select v-model="agedDialog.form.province" placeholder="省" @change="getCitys" clearable>
                                    <el-option
                                        v-for="item in provinces"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="city" label-width="0px">
                                  <el-select v-model="agedDialog.form.city" placeholder="市" @change="getCountys" clearable>
                                    <el-option
                                        v-for="item in citys"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="county" label-width="0px">
                                  <el-select v-model="agedDialog.form.county" placeholder="县" @change="getAreas" clearable>
                                    <el-option
                                        v-for="item in countys"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="area" >
                                  <el-select v-model="agedDialog.form.area" placeholder="区" @change="getStreets" clearable>
                                    <el-option
                                        v-for="item in areas"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="street" label-width="0px">
                                  <el-select v-model="agedDialog.form.street" placeholder="街道"  clearable>
                                    <el-option
                                        v-for="item in streets"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="24">
                                <el-form-item label="地址" prop="location">
                                  <el-input v-model="agedDialog.form.location"
                                            placeholder="请输入地址"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="24">
                                <el-form-item label="注意事项">
                                  <el-input
                                      type="textarea"
                                      :rows="6"
                                      placeholder="请输入服务注意事项"
                                      v-model="agedDialog.form.notices">
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>

                          </div>


                          <div style="margin-top: 60px">
                            <el-row :gutter="20" type="flex" align="middle">
                              <el-col v-if="agedDialog.form.relatives.length > 0" :span="24">
                                <div v-for="(member, index) in agedDialog.form.relatives"
                                     class="family-member-row">
                                  <el-row type="flex" justify="center">
                                    <el-col :span="11">
                                      <el-row>
                                        <!--                                                                <el-col :span="19">-->
                                        <!--                                                                    <el-form-item label="姓名"-->
                                        <!--                                                                                  :rules="{required: true, message: '请输入亲属姓名',trigger:'blur'}"-->
                                        <!--                                                                                  :prop="'relatives['+index+'].name'">-->
                                        <!--                                                                        <el-input v-model="member.name"-->
                                        <!--                                                                                  placeholder="请输入亲属姓名"></el-input>-->
                                        <!--                                                                    </el-form-item>-->
                                        <!--                                                                </el-col>-->
                                        <el-col :span="19">
                                          <el-form-item label="姓名"
                                                        :prop="'relatives['+index+'].name'">
                                            <el-input v-model="member.name"
                                                      placeholder="请输入亲属姓名"></el-input>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="5">
                                          <el-form-item label-width="0px"
                                                        :prop="'relatives['+index+'].relationship'">
                                            <el-select v-model="member.relationship"
                                                       placeholder="请选择亲属关系" clearable>
                                              <el-option label="父母"
                                                         value="PARENTS"></el-option>
                                              <el-option label="子女"
                                                         value="CHILDREN"></el-option>
                                              <el-option label="配偶"
                                                         value="COUPLE"></el-option>
                                              <el-option label="其他亲属"
                                                         value="RELATIVE"></el-option>
                                              <el-option label="护工"
                                                         value="WORKER"></el-option>
                                              <el-option label="其他"
                                                         value="OTHER"></el-option>
                                            </el-select>
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                    </el-col>
                                    <el-col :span="11" :offset="1">
                                      <el-form-item label="监护人"
                                                    :prop="'relatives['+index+'].isGuardian'">
                                        <el-select v-model="member.isGuardian"
                                                   placeholder="请选择是否是监护人">
                                          <el-option label="是" :value="true"></el-option>
                                          <el-option label="否" :value="false"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="11">
                                      <el-form-item label="身份证号">
                                        <el-input v-model="member.idCard"
                                                  placeholder="请输入亲属身份证号"></el-input>
                                      </el-form-item>
                                    </el-col>
                                    <el-col :span="11" :offset="1">
                                      <el-form-item label="联系方式"
                                                    :prop="'relatives['+index+'].phone'">
                                        <el-input v-model="member.phone"
                                                  placeholder="请输入亲属电话"></el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="23">
                                      <el-form-item label="地址">
                                        <el-input v-model="member.location"
                                                  placeholder="请输入地址"></el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="24" style="text-align: center">
                                      <el-button type="danger" @click="removeFamilyMember(index)"
                                                 icon="el-icon-close"></el-button>
                                      <el-button
                                          v-if="index == agedDialog.form.relatives.length - 1"
                                          @click="addFamilyMember"
                                          type="primary" icon="el-icon-plus"></el-button>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                              <el-col v-else :span="24"
                                      style="text-align: center;height: 220px;line-height: 220px">
                                <el-button @click="addFamilyMember" type="primary" icon="el-icon-plus">
                                  添加亲属
                                </el-button>
                              </el-col>
                            </el-row>
                          </div>

                        </el-form>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div style="float:right">
              <el-button @click="HomeVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleUpdate">保存信息</el-button>
            </div>


          </el-tab-pane>
          <el-tab-pane label="现场改造" name="second">
            <div class="dialog-page" :style="{'height':($store.state.minPageHeight - 300) +'px'}">
              <el-scrollbar style="height: 100%">
                <div style="padding-right: 10px">
                  <el-form ref="detailsDialogForm" :model="detailsDialog.form" :rules="detailsDialog.rules" label-width="120px" size="small">
                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;长者信息</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="form-area">
                      <el-col :span="24">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="姓名">
                              <el-input v-model="detailsDialog.form.agedName" placeholder="姓名" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="身份证号">
                              <el-input v-model="detailsDialog.form.idCard" placeholder="请输入身份证号" ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="联系方式">
                              <el-input v-model="detailsDialog.form.agedPhone" placeholder="请输入联系方式" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="服务地址" prop="location">
                              <el-input placeholder="请输入服务地址" v-model="detailsDialog.form.location" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;服务项目</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="网关">
                          <el-input v-model="detailsDialog.form.wangg" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="SOS">
                          <el-input v-model="detailsDialog.form.sos" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="红外">
                          <el-input v-model="detailsDialog.form.hongw" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="门磁">
                          <el-input v-model="detailsDialog.form.menc" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="燃气">
                          <el-input v-model="detailsDialog.form.ranq" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="烟感">
                          <el-input v-model="detailsDialog.form.yang" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="水浸">
                          <el-input v-model="detailsDialog.form.shuij" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="防滑垫">
                          <el-input v-model="detailsDialog.form.fangh" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="护理床">
                          <el-input v-model="detailsDialog.form.hulic" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="床边">
                          <el-input v-model="detailsDialog.form.chuangb" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="扶手">
                          <el-input v-model="detailsDialog.form.fus" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="沐浴椅">
                          <el-input v-model="detailsDialog.form.muyuy" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="手杖">
                          <el-input v-model="detailsDialog.form.shouz" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="轮椅">
                          <el-input v-model="detailsDialog.form.luny" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="助行器">
                          <el-input v-model="detailsDialog.form.zhuxq" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="床带">
                          <el-input v-model="detailsDialog.form.chuangd" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="摄像头">
                          <el-input v-model="detailsDialog.form.shexiangt" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="小夜灯">
                          <el-input v-model="detailsDialog.form.xiaoyed" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="手环">
                          <el-input v-model="detailsDialog.form.shouhuan" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="高差处理">
                          <el-input v-model="detailsDialog.form.gaocha" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;修改原因</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="form-area">
                      <el-col :span="24">
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="原因" prop="updateReason">
                              <el-input
                                  type="textarea"
                                  :rows="6"
                                  placeholder="请输入修改原因"
                                  v-model="detailsDialog.form.updateReason"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="家庭养老床位建设验收单">
                              <template v-for="file in detailsDialog.form.xmqrsFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.xmqrsFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->
                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="xmqrsUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>




                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防滑处理前">
                              <template v-for="file in detailsDialog.form.aaFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aaFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aaUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防滑处理后">
                              <template v-for="file in detailsDialog.form.bbFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.bbFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="bbUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="高差处理前">
                              <template v-for="file in detailsDialog.form.ccFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ccFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ccUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="高差处理后">
                              <template v-for="file in detailsDialog.form.ddFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ddFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ddUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置护理床前">
                              <template v-for="file in detailsDialog.form.eeFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.eeFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="eeUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置护理床后">
                              <template v-for="file in detailsDialog.form.ffFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ffFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ffUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装床边前">
                              <template v-for="file in detailsDialog.form.ggFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ggFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ggUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装床边后">
                              <template v-for="file in detailsDialog.form.hhFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.hhFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="hhUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装扶手前">
                              <template v-for="file in detailsDialog.form.iiFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.iiFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="iiUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装扶手后">
                              <template v-for="file in detailsDialog.form.jjFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.jjFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="jjUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置淋浴椅前">
                              <template v-for="file in detailsDialog.form.kkFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.kkFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="kkUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置淋浴椅后">
                              <template v-for="file in detailsDialog.form.llFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.llFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="llUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="手杖前">
                              <template v-for="file in detailsDialog.form.mmFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.mmFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="mmUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="手杖后">
                              <template v-for="file in detailsDialog.form.nnFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.nnFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="nnUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="轮椅前">
                              <template v-for="file in detailsDialog.form.ooFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ooFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ooUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="轮椅后">
                              <template v-for="file in detailsDialog.form.ppFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ppFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ppUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="助行器前">
                              <template v-for="file in detailsDialog.form.qqFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.qqFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="qqUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="助行器后">
                              <template v-for="file in detailsDialog.form.rrFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.rrFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="rrUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="智能网关前">
                              <template v-for="file in detailsDialog.form.ssFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ssFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ssUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="智能网关后">
                              <template v-for="file in detailsDialog.form.ttFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ttFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ttUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="无线紧急呼叫设备前">
                              <template v-for="file in detailsDialog.form.uuFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.uuFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="uuUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="无线紧急呼叫设备后">
                              <template v-for="file in detailsDialog.form.vvFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.vvFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="vvUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="烟雾报警器前">
                              <template v-for="file in detailsDialog.form.wwFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.wwFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="wwUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="烟雾报警器后">
                              <template v-for="file in detailsDialog.form.xxFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.xxFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="xxUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="燃气报警器前">
                              <template v-for="file in detailsDialog.form.yyFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.yyFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="yyUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="燃气报警器后">
                              <template v-for="file in detailsDialog.form.zzFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.zzFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="zzUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="睡眠监测设备前">
                              <template v-for="file in detailsDialog.form.aaaFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aaaFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aaaUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="睡眠监测设备后">
                              <template v-for="file in detailsDialog.form.abbFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.abbFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="abbUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装自动感应灯具前">
                              <template v-for="file in detailsDialog.form.accFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.accFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="accUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装自动感应灯具后">
                              <template v-for="file in detailsDialog.form.addFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.addFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="addUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="门磁感应器前">
                              <template v-for="file in detailsDialog.form.aeeFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aeeFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aeeUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="门磁感应器后">
                              <template v-for="file in detailsDialog.form.affFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.affFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="affUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="语音或视频通话设备前">
                              <template v-for="file in detailsDialog.form.aggFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aggFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aggUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="语音或视频通话设备后">
                              <template v-for="file in detailsDialog.form.ahhFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ahhFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ahhUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防走失装置前">
                              <template v-for="file in detailsDialog.form.aiiFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aiiFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aiiUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防走失装置后">
                              <template v-for="file in detailsDialog.form.hFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.hFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="houUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="红外改造前">
                              <template v-for="file in detailsDialog.form.ajjFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ajjFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ajjUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="红外改造后">
                              <template v-for="file in detailsDialog.form.akkFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.akkFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="akkUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="水浸改造前">
                              <template v-for="file in detailsDialog.form.allFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.allFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="allUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="水浸改造后">
                              <template v-for="file in detailsDialog.form.ammFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ammFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ammUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>

                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-scrollbar>
            </div>
            <!--                        <div style="float:right">-->
            <!--                            <el-button @click="HomeVisible = false">取 消</el-button>-->
            <!--                            <el-button type="primary" @click="handleUpdWo">保 存</el-button>-->
            <!--                        </div>-->

          </el-tab-pane>
          <el-tab-pane label="告警信息" name="third">
            <el-row :gutter="20" class="out-border">
              <el-col :span="24">
                <div class="page-content">
                  <div>
                    <el-table :data="NBiotEventTable.data" highlight-current-row>
                      <el-table-column prop="agedName" label="告警老人"></el-table-column>
                      <el-table-column prop="status" label="状态">
                        <template scope="scope">
                          <span v-if="scope.row.status==='报警'" style="color: green">已处理（报警）</span>
                          <span v-if="scope.row.status==='测试'" style="color: green">已处理（测试）</span>
                          <span v-if="scope.row.status==='误报'" style="color: green">已处理（误报）</span>
                          <span v-if="scope.row.status==='演练'" style="color: green">已处理（演练）</span>
                          <span v-if="scope.row.status==='告警'" style="color: red">发生告警</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="type" label="设备类型">
                        <template scope="scope">
                          <span v-if="scope.row.type==='SOS'" >SOS告警</span>
                          <span v-if="scope.row.type==='GAS'" >燃气告警</span>
                          <span v-if="scope.row.type==='WATER'" >水浸告警</span>
                          <span v-if="scope.row.type==='Smoke'" >烟雾告警</span>
                          <span v-if="scope.row.type==='Infrared'" >红外告警</span>
                          <span v-if="scope.row.type==='DOOR'" >门磁告警</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="textAged" label="处理人"></el-table-column>
                      <el-table-column prop="createTime" label="告警时间"></el-table-column>
                      <el-table-column prop="content" label="告警信息"></el-table-column>
                      <el-table-column prop="textRead" label="处理方式"></el-table-column>
                      <el-table-column prop="textText" label="处理结果"></el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope" >
                          <el-button size="mini" type="text" @click="handleNBiotEdit(scope.row.id)">处理</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="pagination">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="NBiotEventTable"
                        :current-page.sync="NBiotEventTable.page.currentPage"
                        :page-sizes="[10, 50, 100]"
                        :page-size.sync="NBiotEventTable.page.pageSize"
                        layout="sizes,  prev, pager, next, total"
                        :total="NBiotEventTable.page.total">
                    </el-pagination>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>


    </el-dialog>





  </div>
</template>

<script>
import {
  detailsWoDialogHOME,
  getAgedTableHOME,
  getDataQtyHOME, getDataQtyHOMEOld,
  getNBiotEventAgedTableHOME, getNBiotEventTableHOME,
  getPlatfromNameHOME, handleNBiotEditHOME, handleUpdHOME,
  loadEventsHOME
} from "@/api/home-new";
import result from "element-ui/packages/result";
import {getGetProvinces, getHandleLoadData, getNextLevel} from "@/api/aged/aged_record";
import router from "@/router";

export default {
  name: "home-new",
  data: function () {
    return {
      ip:'/system-ya',
      HomeVisibleAged:true,
      HomeVisibleTitle:"老人档案",
      activeName: 'first',
      HomeVisible:false,
      agedId:"",
      SOS:'150',
      i:'0',
      events:[],
      agedHealthTable:{
        condition: {
          "info":'',
          "agedName":'',
          "agedSex":'',
          "idCard":'',
          "location":'',
          "phone":'',

        },
        page: {
          "currentPage": 1,
          "pageSize": 8,
          "total": 0
        },
        data: [],
      },
      DataQty:{
        water:'',
        sos:'',
        gas:'',
        smoke:'',
        infrared:'',
        door:'',
        wuoc:'',
      },
      DataQtyOld:{
        water:'',
        sos:'',
        gas:'',
        smoke:'',
        infrared:'',
        door:'',
        wuoc:'',
      },
      NBiotEventTable: {
        condition: {
          "type": "",
        },
        page: {
          "currentPage": 1,
          "pageSize": 10,
          "total": 0
        },
        data: []
      },
      NBiotEventTableVisible:false,
      NBiotEventTableTitle:'告警信息',
      NBiotDialogVisible:false,
      NBiotDialogTitle:'处理',
      NBiotEventInfo:{
        id:'',
        type:'',
        agedId:'',
        agedName:'',
        createTime:'',
        project:'',
        content:'',
        status:'',
        textAged:'',
        textRead:'',
        textText:'',
        code:'',
        familyId:'',
        deviceId:'',
        deviceType:'',
        alarmStatus:'',
        priority:'',
        seatId:'',
        startTime:'',
        endTime:'',
        behaviorException:'',
        workOrders:'',

      },
      dataName:[],
      reportDialog:{
        visible: false,
        title: '日报',
        data:{

        },
        message:{}
      },
      agedHome:'',
      CDaiPage:'',

      agedDialog: {
        mode: 1,
        visible: false,
        title: '新的长者',
        form: {
          id: '',
          icon: '',
          remove:'',
          familyId: '',
          projectId:'',
          serviceOffer:'',
          idCard: '',
          cardType: 'ID_CARD',
          agedName: '',
          agedSex: 1,
          birthday: '',
          birthDateType: 1,
          phone: '',
          salesAmount:'',
          reformAmount:'',
          isLocal: true,
          subsidyStandard: '',
          agedSource: 'SOCIETY',
          callbackSupport: true,
          agedType: '',
          serviceStatus: 'NORMAL',
          notices: '',
          followNotes:'',
          location: '',
          address: '',
          lng: '',
          lat: '',
          relatives: [{
            id: '',
            name: '',
            phone: '',
            idCard: '',
            relationship: '',
            isGuardian: true,
            location: ''
          }],
          nickName: '',
          marriageStatus: '',
          politicalOutlook: '',
          bloodType: '',
          nation: '',
          religious: '',
          education: '',
          population: 1,
          holdType: '',
          offerStandard: '',
          offerType: '',
          hobby: '',
          permanentAddress: '',
          province:'',
          city:'',
          county:'',
          area:'',
          street:'',
          xiaoxinhuan:''
        },
        rules: {
          // idCard: [
          //     {required: true, message: '证件号不能为空', trigger: 'blur'},
          //     { min: 18, max: 18, message: '请输入有效身份证号', trigger: 'blur' }
          // ],
          // agedName: [
          //     {required: true, message: '长者姓名不能为空', trigger: 'blur'}
          // ],
          // phone: [
          //     {required: true, message: '联系电话不能为空', trigger: 'blur'},
          //     { min: 11, max:11, message: '请输入有效手机号码', trigger: 'blur' }
          // ],
          // serviceOffer:[
          //     { required: true, message: '请选择服务商', trigger: 'blur'}
          // ],
          // projectId:[
          //     { required: true, message: '请选择所属项目', trigger: 'blur'}
          // ],
          // location: [
          //     {required: true, message: '地址不能为空', trigger: 'blur'}
          // ],
          // province:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // city:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // county:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // area:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // street:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // location:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
        }
      },
      citys:[],
      countys:[],

      detailsDialog: {
        visible: false,
        title: '详情',
        form: {
          id: '',
          agedId: '',
          agedName:'',
          idCard: '',
          agedPhone: '',
          location: '',
          agedFamilyId:'',
          agedFamilyName:'',
          servicePerson:'',
          woType: '',
          notices: '',
          serviceOffer: '',
          servicePersonId: '',
          name:'',
          serviceType: '',
          serviceCycle: '',
          planStartTime: '',
          planEndTime: '',
          workOrderContentId: '',
          serviceContent: '',
          woSource: '',
          unitPrice: '',
          priceMode: '',
          updateReason: '',
          workOrderContent:'',
          remarks:'',
          files:[],
          cFiles:[],
          wFiles:[],
          kFiles:[],
          qFiles:[],
          hFiles:[],
          qrsFiles:[],
          aaFiles:[],
          bbFiles:[],
          ccFiles:[],
          ddFiles:[],
          eeFiles:[],
          ffFiles:[],
          ggFiles:[],
          hhFiles:[],
          iiFiles:[],
          jjFiles:[],
          kkFiles:[],
          llFiles:[],
          mmFiles:[],
          nnFiles:[],
          ooFiles:[],
          ppFiles:[],
          qqFiles:[],
          rrFiles:[],
          ssFiles:[],
          ttFiles:[],

          uuFiles:[],
          vvFiles:[],
          wwFiles:[],
          xxFiles:[],
          yyFiles:[],
          zzFiles:[],
          aaaFiles:[],
          abbFiles:[],
          accFiles:[],
          addFiles:[],
          aeeFiles:[],
          affFiles:[],
          aggFiles:[],
          ahhFiles:[],
          aiiFiles:[],

          ajjFiles:[],
          akkFiles:[],
          allFiles:[],
          ammFiles:[],
          annFiles:[],
          aooFiles:[],
          appFiles:[],
          aqqFiles:[],
          examineCivil:'',
          examineProject:'',

          wangg:'',
          sos:'',
          hongw:'',
          menc:'',
          ranq:'',
          yang:'',
          shuij:'',
          fangh:'',
          hulic:'',
          chuangb:'',
          fus:'',
          muyuy:'',
          shouz:'',
          luny:'',
          zhuxq:'',
          chuangd:'',
          shexiangt:'',
          xiaoyed:'',
          shouhuan:'',
          gaocha:'',
        },
      },

    }
  },
  mounted: function () {
    this.getAgedTable();
    // this.getPlatfromName();
    this.getDataQty();
    this.getDataQtyOld();
    this.loadEvents();
    // setInterval(() => {
    //     this.loadEvents();
    // }, 75000);

  },
  methods: {


    choice(id){
      this.getProvinces();
      this.handleLoadData(id);
      this.getNBiotEventAgedTable(id);
      this.detailsWoDialog(id);

    },


    ceshi(id){
      this.HomeVisible=false;
      this.handleReport(id);
    },

    getAgedTable(){
      let me = this;
      let param = {};
      param.page = {
        currentPage:me.agedHealthTable.page.currentPage,
        pageSize:me.agedHealthTable.page.pageSize
      };
      param.condition = me.agedHealthTable.condition;
      getAgedTableHOME(param)
          .then(result=>{
            if(result.data){
              me.agedHealthTable.data = result.data.content;
              me.agedHealthTable.page.currentPage = result.data.page.currentPage;
              me.agedHealthTable.page.total = result.data.page.total;

              for(me.i = 0; me.i < 8; me.i++){
                if(me.agedHealthTable.data[me.i].agedSex == "0"){
                  me.agedHealthTable.data[me.i].agedSex = "女";

                }else if(me.agedHealthTable.data[me.i].agedSex == 1){
                  me.agedHealthTable.data[me.i].agedSex = "男";

                }
              };
            }
          })
    },


    getPlatfromName:function () {
      let me = this;
      getPlatfromNameHOME()
          .then(result=>{
            me.dataName = result.data;
            if(me.dataName.bedName == null || me.dataName.bedName == ""){
              me.dataName.bedName = "家庭养老床位";
            }
          })
    },


    myChart(){
      let me = this;
      let data_2 = echarts.init(document.getElementById('data_2'));
      let data_2_option = {
        tooltip: {
          trigger: 'axis', // 当触发类型为坐标轴时触发提示框
          axisPointer: {
            type: 'shadow' // 默认为line，可选'shadow'使指示器呈现阴影效果
          },
          formatter: function (params) { // 自定义提示框内容格式
            let param = params[0];
            return `告警: ${param.name}<br/>次数: ${param.value}`;
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,    //强制文字产生间隔
            rotate: 45,     //文字逆时针旋转45°
            textStyle: {    //文字样式
              color: "black",
              fontSize: 10,
              fontFamily: 'Microsoft YaHei'
            }
          },
          // data: ['SOS告警', '烟感告警', '水浸告警', '红外告警', '门磁告警','燃气告警','卧床告警']
          data:me.DataQty.gaoJin,
        },
        yAxis: {
          type: 'value',

        },
        series: [
          {
            // data: [70, 1, 3, 2, 8, 5],
            data:me.DataQty.gaoJinSl,
            markPoint: {
              symbolSize: 50, // 可以调整标记点的大小
              label: {
                show: true,
                color: '#1E1F22', // 设置标记点文字的颜色
                fontSize: 12, // 设置字体大小
              },
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            },
            type: 'bar',
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            itemStyle: {    // 图形的形状
              normal: {
                label: {
                  // show: true, //开启显示数值
                  position: 'top', //数值在上方显示
                  textStyle: {  //数值样式
                    color: '#66DEE7',   //字体颜色
                    fontSize: 14  //字体大小
                  }
                },
                barBorderRadius: [18, 18, 0 ,0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#2FFAFF'
                }, {
                  offset: 1,
                  color: '#0475D0'
                }]),
              },
            },
            barWidth: 10
          }
        ],

        grid:{
          y:20,
          y2:20,
          bottom: 40, // 增加此行以调整x轴文字显示的高度，数值可以根据实际情况进行调整
        },
      };

      data_2.setOption(data_2_option);
      data_2.resize();

    },

    loadEvents(){
      let me = this;
      me.events = null;
      loadEventsHOME()
          .then(result=>{
            if(result.data){
              me.events = result.data;
            }
          })
    },

    getDataQty(){
      let me = this;
      getDataQtyHOME()
          .then(result=>{
            if(result.data){
              me.DataQty = result.data;
              console.log(me.DataQty);
              me.myChart();
            }
          })
    },

    getDataQtyOld(){
      let me = this;
      getDataQtyHOMEOld()
          .then(result=>{
            if(result.data){
              me.DataQtyOld = result.data;
              me.DataQtyOld.wuoC = 0;
            }else {
              me.DataQtyOld.wuoC = 0;
              me.DataQtyOld.sos = 0;
              me.DataQtyOld.smoke = 0;
              me.DataQtyOld.water = 0;
              me.DataQtyOld.infrared = 0;
              me.DataQtyOld.door = 0;
              me.DataQtyOld.gas = 0;
            }
          })
    },

    getNBiotEventTable(){
      let me = this;
      let param = {};
      param.page = {
        currentPage:me.NBiotEventTable.page.currentPage,
        pageSize:me.NBiotEventTable.page.pageSize
      };
      param.condition = me.NBiotEventTable.condition;
      getNBiotEventTableHOME(param)
          .then(result=>{
            if(result.data){
              me.NBiotEventTable.data = result.data.content;
              me.NBiotEventTable.page.currentPage = result.data.page.currentPage;
              me.NBiotEventTable.page.total = result.data.page.total;
            }
          })
    },

    GetGJXX(id){
      this.NBiotEventTableVisible = true;
      this.getNBiotEventAgedTable(id);
    },

    //单个老人告警查询
    getNBiotEventAgedTable(id){
      let me = this;
      me.HomeVisible=false;
      let param = {};
      me.NBiotEventTable.condition.type = id;
      me.agedId = id;
      param.page = {
        currentPage:me.NBiotEventTable.page.currentPage,
        pageSize:me.NBiotEventTable.page.pageSize
      };
      param.condition = me.NBiotEventTable.condition;
      getNBiotEventAgedTableHOME(param)
          .then(result=>{
            if(result.data){
              me.NBiotEventTable.data = result.data.content;
              me.NBiotEventTable.page.currentPage = result.data.page.currentPage;
              me.NBiotEventTable.page.total = result.data.page.total;
            }
          })
    },



    //详情
    handleNBiotEdit:function (id) {
      let me =this;
      handleNBiotEditHOME(id)
          .then(result=>{
            let NBiotEventInfo = result.data;
            if(NBiotEventInfo){
              me.fillNBiotForm(NBiotEventInfo);
              // me.getNBiotOlder();
              me.NBiotEventTableVisible = false;
              me.NBiotDialogVisible = true;
            }
          })
    },


    fillNBiotForm:function (NBiotEventInfo) {
      let me = this;
      me.NBiotEventInfo = NBiotEventInfo;
      me.NBiotEventInfo.status = "报警";
    },

    //更新
    handleUpd(){
      let me = this;
      let param = this.NBiotEventInfo;
      handleUpdHOME(param)
          .then(result=>{
            if(result.data){
              me.$message.success("处理成功");
              me.NBiotDialogVisible = false;
              me.NBiotEventTableVisible = true;
              if(me.NBiotEventTable.condition.type == me.agedId){
                me.getNBiotEventAgedTable(me.agedId);
              }else {
                me.getNBiotEventTable();
              }
              me.getDataQty();
            }
          })
    },

    choiceSOS(){
      let me = this;
      me.NBiotEventTable.condition.type = "SOS";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true

    },

    choiceGAS(){
      let me = this;
      me.NBiotEventTable.condition.type = "GAS";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceWATER(){
      let me = this;
      me.NBiotEventTable.condition.type = "WATER";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceSmoke(){
      let me = this;
      me.NBiotEventTable.condition.type = "Smoke";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceInfrared(){
      let me = this;
      me.NBiotEventTable.condition.type = "Infrared";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceDOOR(){
      let me = this;
      me.NBiotEventTable.condition.type = "DOOR";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    getNowData:function(createTime){
      // let me = this;
      let timestamp = (new Date()).getTime();
      let stringTime = createTime;
      let timestamp2 = Date.parse(new Date(stringTime));
      let judge = timestamp - timestamp2 <= 10000;
      return judge;

    },

    //详情
    lodWoTab:function () {
      let me =this;
      $.ajax({
        url: "/gongDanGuanLian/generate/",
        type: 'GET',
        dataType:"json",
        contentType: 'application/json;charset=UTF-8',
        success: function (result) {

        }
      });
    },

    //床带
    handleReport(id) {
      let me = this;
      $.ajax({
        url: "chuangdai/infoHome/"+id,
        type: 'GET',
        success: function (result) {
          if(result.data){
            me.reportDialog.visible = true;
            me.reportDialog.data = result.data.cdRes.data;
            me.reportDialog.message = result.data.message;
            // me.reportDialog.title = result.data.mark[0].date;
            me.$nextTick(()=>{
              me.initHxBar();
              me.initXlLine();
              // me.initsocket(result.data.serial)
            })
          }
        }
      });
    },

    //查询是否有床带
    handleReportAgedHome(id) {
      let me = this;
      $.ajax({
        url: "chuangdai/AgedHome/"+id,
        type: 'GET',
        success: function (result) {
          me.agedHome = result.data;
          if(me.agedHome == "0"){
            me.agedHealthTable.data[me.i].CDaiPage = "../static/asert/image/report/icon-1.3.4.png";
          }else if(me.agedHome == "1"){
            me.agedHealthTable.data[me.i].CDaiPage = "../static/asert/image/report/icon-1.3.4.png";
          }


        }
      });
    },


    initHxBar(){
      let me = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('hx-bar'));
      let option = {
        xAxis: {
          type: 'category',
          data: me.reportDialog.data.dt_arr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: me.reportDialog.data.hx_arr,
            type: 'bar'
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    initXlLine(){
      let me = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('xl-line'));
      let option =  {
        xAxis: {
          type: 'category',
          data: me.reportDialog.data.dt_arr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: me.reportDialog.data.rh_arr,
            type: 'line'
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },


    handleLoadData(id) {
      if (!id) {
        return false;
      }
      let me = this;
      me.clearAgedForm();
      getHandleLoadData(id)
          .then(result=>{
            if (result.data) {
              me.agedDialog.form = result.data;
              me.agedDialog.mode = 2;
              me.HomeVisible = true;
              me.HomeTitle = "老人信息"
              if (!result.data.city){
                return;
              }else {
                //加载县
                me.getCounty(result.data.city);
              };
              if (!result.data.province){
                return;
              }else {
                //加载市
                me.getCity(result.data.province);
              };
              if (!result.data.county){
                return;
              }else {
                //加载区
                me.getArea(result.data.county);
              };
              if (!result.data.area){
                return;
              }else {
                //加载街道
                me.getStreet(result.data.area);
              };
            }
          })
    },

    clearAgedForm() {
      this.agedDialog.form = {
        id: '',
        icon: '',
        familyId: '',
        projectId:'',
        idCard: '',
        serviceOffer:'',
        cardType: 'ID_CARD',
        agedName: '',
        agedSex: 1,
        birthday: '',
        birthDateType: 1,
        phone: '',
        salesAmount:'',
        reformAmount:'',
        isLocal: true,
        subsidyStandard: '',
        agedSource: 'SOCIETY',
        callbackSupport: true,
        agedType: '',
        serviceStatus: 'NORMAL',
        notices: '',
        followNotes:'',
        location: '',
        'address': '',
        'lng': '',
        'lat': '',
        relatives: [{
          id: '',
          name: '',
          phone: '',
          idCard: '',
          relationship: '',
          isGuardian: true,
          location: ''
        }],
        nickName: '',
        marriageStatus: '',
        politicalOutlook: '',
        bloodType: '',
        nation: '',
        religious: '',
        education: '',
        population: 1,
        holdType: '',
        offerStandard: '',
        offerType: '',
        hobby: '',
        permanentAddress: '',
      }
    },

    //获取省
    getProvinces:function () {
      let me = this;
      getGetProvinces()
          .then(result=>{
            if(result.data){
              me.provinces = result.data;
            }
          })
    },
    getCitys:function (parentId) {
      this.agedDialog.form.city = '';
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.city = '';
      this.healthTable.condition.county = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearCitys();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.citys = result.data;
              }
            })
      }

    },
    getCity:function (parentId) {
      let me = this;
      me.citys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.citys = result.data;
            }
          })
    },
    getCountys:function (parentId) {
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.county = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearAreas();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.countys = result.data;
              }
            })
      }
    },
    getCounty:function (parentId) {
      let me = this;
      me.countys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.countys = result.data;
            }
          })
    },
    getAreas:function (parentId) {
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearStreets();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.areas = result.data;
              }
            })
      }
    },
    getArea:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.areas = result.data;
            }
          })
    },
    getStreets:function (parentId) {
      this.agedDialog.form.street = '';
      this.healthTable.condition.street = '';
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    getStreet:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    clearCitys:function () {
      let me = this;
      me.citys = [];
      me.clearCountys();
    },
    clearCountys:function () {
      let me = this;
      me.countys = [];
      me.clearAreas();
    },
    clearAreas:function () {
      let me = this;
      me.areas = [];
      me.clearStreets();
    },
    clearStreets:function () {
      let me = this;
      me.streets = [];
    },

    handleUpdate() {
      let me = this;
      this.$refs['aged-form'].validate((valid) => {
        if (valid) {
          let param = this.agedDialog.form;
          $.ajax({
            url: "aged/upd",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              me.$message.success("保存成功");
              me.closeAgedDialog();
            }
          });
        }
      });
    },

    closeAgedDialog() {
      this.HomeVisible = false;
      this.getAgedTable();
      this.clearAgedForm();
    },


    handleProviderChange(){
      this.detailsDialog.form.servicePersonId = '';
    },
    toggleSearchArea(){
      if(this.moreSearch){
        this.moreSearch = false;
      } else {
        this.moreSearch = true;
      }
    },
    loadOffers(){
      let me = this;
      $.ajax({
        url: "provider/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.offers = result.data;
          }
        }
      });
    },
    loadAgedFiles(id){
      let me = this;
      $.ajax({
        url: "constructionProgramme/"+id+"/files",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.files = result.data;
          }
        }
      });
    },
    allFile(files){
      return files.map((file)=>{
        return file.filePath
      });
    },
    loadWoTable(){
      let me = this;

      this.woTable.currentRow = '';
      this.buttonStatus = 0;

      let param = {};
      param.page = {
        currentPage:me.woTable.page.currentPage,
        pageSize:me.woTable.page.pageSize
      };
      param.condition = me.woTable.condition;

      $.ajax({
        url: "constructionProgramme/selectAllTable",
        type: 'POST',
        data:JSON.stringify(param),
        success: function (result) {
          if(result.data){
            me.woTable.data = result.data.content;
            me.woTable.page.currentPage = result.data.page.currentPage;
            me.woTable.page.total = result.data.page.total;

          }
        }
      });
    },
    loadEms(){
      let me = this;
      $.ajax({
        url: "em/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.servicePersons = result.data;
          }
        }
      });
    },
    loadProviderEms(){
      let me = this;
      if(!this.detailsDialog.form.serviceOffer && this.detailsDialog.form.serviceOffer !== 0){
        me.servicePersons = [];
        return;
      }
      $.ajax({
        url: "provider/em/list/" + this.detailsDialog.form.serviceOffer,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.servicePersons = result.data;
          } else {
            me.servicePersons = [];
          }
        }
      });
    },
    loadWorkOrderContents(){
      let me = this;
      $.ajax({
        url: "wo/content/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.workOrderContents = result.data;
          }
        }
      });
    },
    woSelectionChange(row, column){
      this.woTable.currentRow = row;
      this.buttonStatus = 0;
      switch (row.woStatus) {
        case 'CREATE':
          this.buttonStatus = 1;
          break;
        case 'APPROVE':
          this.buttonStatus = 2;
          break;
        case 'PUBLISH':
          this.buttonStatus = 3;
          break;
        case 'PROGRESS':
          this.buttonStatus = 4;
          break;
        case 'PAUSE':
          this.buttonStatus = 5;
          break;
        case 'FINISH':
          this.buttonStatus = 6;
          break;
        case 'EVALUATED':
          this.buttonStatus = 7;
          break;
        case 'VERIFIED':
          this.buttonStatus = 8;
          break;
        case 'ARCHIVED':
          this.buttonStatus = 9;
          break;
        case 'CLOSED':
          this.buttonStatus = 10;
          break;
      }
    },
    approveWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.approveDialog.visible){
        this.approveDialog.visible = true;
        this.approveDialog.title = '工单审批 - [ '+this.woTable.currentRow.woCode+' ]';
        this.approveDialog.form.woId = this.woTable.currentRow.id;
        this.approveDialog.form.value = '1';
        this.approveDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.approveWoForm.validate((valid) => {
        if (valid) {
          let param = this.approveDialog.form;
          $.ajax({
            url: "wo/approve",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("审批成功");
                me.loadWoTable();
                me.approveDialog.visible = false;
              }
            }
          });
        }
      });

    },
    publishWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否发布此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/publish",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("发布成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    acceptWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否接受此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/accept",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("接单成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    backWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;
      this.$prompt('请输入退单原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写退单原因'
      }).then(({ value }) => {
        let param = {
          woId:me.woTable.currentRow.id,
          content:value
        };
        $.ajax({
          url: "wo/back",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("退单成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    finishWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否完成此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/finish",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("操作成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    evaluateWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.evaluateDialog.visible){
        this.evaluateDialog.visible = true;
        this.evaluateDialog.title = '工单回访 - [ '+this.woTable.currentRow.woCode+' ]';
        this.evaluateDialog.form.woId = this.woTable.currentRow.id;
        this.evaluateDialog.form.value = 0;
        this.evaluateDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.evaluateWoForm.validate((valid) => {
        if (valid) {
          let param = this.evaluateDialog.form;
          $.ajax({
            url: "wo/evaluate",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("回访成功");
                me.loadWoTable();
                me.evaluateDialog.visible = false;
              }
            }
          });
        }
      });
    },
    verifiedWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.verifiedDialog.visible){
        this.verifiedDialog.visible = true;
        this.verifiedDialog.title = '工单验证 - [ '+this.woTable.currentRow.woCode+' ]';
        this.verifiedDialog.form.woId = this.woTable.currentRow.id;
        this.verifiedDialog.form.value = '1';
        this.verifiedDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.verifiedWoForm.validate((valid) => {
        if (valid) {
          let param = this.verifiedDialog.form;
          $.ajax({
            url: "wo/verified",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("验证成功");
                me.loadWoTable();
                me.verifiedDialog.visible = false;
              }
            }
          });
        }
      });
    },
    archiveWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否存档此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/archive",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("存档成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    closeWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否终止此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/close",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("终止成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    pauseWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$prompt('请输入暂停原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写暂停原因'
      }).then(({ value }) => {
        let param = {
          woId:me.woTable.currentRow.id,
          content:value
        };
        $.ajax({
          url: "wo/pause",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("暂停成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    resumeWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否恢复此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/resume",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("恢复成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    remove(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要删除的工单");
        return;
      }
      this.$confirm('是否删除此工单?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        $.ajax({
          url: "constructionProgramme/remove/"+id,
          type: 'GET',
          success: function (result) {
            me.$message.success("删除成功");
            me.loadWoTable();
          }
        });
      });
    },
    showActivity(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要查看的工单");
        return;
      }
      $.ajax({
        url: "wo/activities/"+id,
        type: 'GET',
        success: function (result) {
          if(result.data){
            me.activitiesDialog.data.woActivities = result.data;
            me.activitiesDialog.visible = true;
          }
        }
      });
    },

    openUpdateWoDialog(id){
      this.clearWoForm();
      let me = this;
      $.ajax({
        url: "constructionProgramme/info/"+id,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.woDialog.visible = true;
            me.woDialog.form = result.data;
            me.woDialog.title = "编辑工单";

          }
        }
      });
    },

    changeUpdateWoDialog(id){
      this.clearWoForm();
      let me = this;
      $.ajax({
        url: "constructionProgramme/info/"+id,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.changeDialog.visible = true;
            me.woDialog.form = result.data;
            me.changeDialog.title = "改派工单";
          }
        }
      });
    },



    detailsWoDialog(id){
      this.clearDetailsDialog();
      let me = this;
      // me.id = id;
      detailsWoDialogHOME(id)
          .then(result=>{
            if(result.data){
              me.detailsDialog.visible = true;
              me.detailsDialog.form = result.data;
              me.detailsDialog.title = "编辑";
            }
          })
    },

    handleUpdWo(){
      let me = this;
      me.copydata();
      let param = this.datanew;
      $.ajax({
        url: "constructionProgramme/upd",
        type: 'POST',
        data: JSON.stringify(param),
        success: function (result) {
          if(result.data){
            me.$message.success("保存成功");
            me.detailsDialog.visible = false;
            me.loadWoTable();
            me.clearDataNew();
            me.getAllData();
            me.getDataQty();
            me.HomeVisible = false;
          }
        }
      });


    },

    clearWoForm(){
      this.woDialog.form = {
        id:'',
        agedId:'',
        agedIdCard:'',
        agedPhone:'',
        location:'',
        woType:'',
        notices:'',
        serviceOffer:'',
        servicePersonId:'',
        serviceType:'',
        serviceCycle:'',
        planStartTime:'',
        planEndTime:'',
        serviceContent:'',
        woSource:'',
        unitPrice:'',
        priceMode:'',
        updateReason:''
      };
      if(this.$refs.woDialogForm){
        this.$nextTick(()=>{
          this.$refs.woDialogForm.clearValidate();
        })
      }
    },


    qianUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Qian');
    },
    houUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Hou');
    },
    qrsUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Qrs');
    },
    xmqrsUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Xmqrs');
    },
    aaUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AA');
    },
    bbUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'BB');
    },
    ccUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'CC');
    },
    ddUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'DD');
    },
    eeUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'EE');
    },
    ffUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'FF');
    },
    ggUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'GG');
    },
    hhUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'HH');
    },
    iiUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'II');
    },
    jjUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'JJ');
    },
    kkUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'KK');
    },
    llUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'LL');
    },
    mmUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'MM');
    },
    nnUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'NN');
    },
    ooUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'OO');
    },
    ppUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'PP');
    },
    qqUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'QQ');
    },
    rrUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'RR');
    },
    ssUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'SS');
    },
    ttUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'TT');
    },

    uuUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'UU');
    },
    vvUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'VV');
    },
    wwUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'WW');
    },
    xxUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'XX');
    },
    yyUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'YY');
    },
    zzUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ZZ');
    },
    aaaUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AAA');
    },
    abbUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ABB');
    },
    accUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ACC');
    },
    addUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ADD');
    },
    aeeUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AEE');
    },
    affUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AFF');
    },
    aggUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AGG');
    },
    ahhUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AHH');
    },
    aiiUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AII');
    },
    ajjUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AJJ');
    },
    akkUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AKK');
    },
    allUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ALL');
    },
    ammUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AMM');
    },
    annUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ANN');
    },
    aooUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AOO');
    },
    appUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'APP');
    },
    aqqUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AQQ');
    },
    handleFileSuccess(agedId, fileId, type) {
      let me = this;
      if (!agedId || !fileId) {
        return;
      }
      $.ajax({
        url: "constructionProgramme/file/add",
        type: 'POST',
        data:JSON.stringify({
          constructionProgrammeId:me.id,
          fileId:fileId,
          type:type,
        }),
        success: function (result) {
          if(result.data){
            me.$message.success("上传成功");
            me.loadFiles();
          }else {
            me.$message.error("上传失败");
          }
        }
      });
    },

    removeFile(fileId){
      let me = this;
      if (!fileId) {
        return;
      }
      this.$confirm('是否移除此附件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        $.ajax({
          url: "constructionProgramme/file/remove",
          type: 'POST',
          data:JSON.stringify({
            fileId:fileId
          }),
          success: function (result) {
            if(result.data){
              me.$message.success("移除成功");
              me.loadFiles();
            }else {
              me.$message.error("移除失败");
            }
          }
        });
      }).catch(()=>{});
    },
    loadFiles(){
      let me = this;
      if (!me.id) {
        return;
      }
      $.ajax({
        url: "constructionProgramme/"+me.id+"/files",
        type: 'POST',
        success: function (result) {
          if(result.data){
            // me.woDialog.form.files = result.data.files;
            me.detailsDialog.form.qFiles = result.data.qFiles;
            me.detailsDialog.form.hFiles = result.data.hFiles;
            me.detailsDialog.form.qrsFiles = result.data.qrsFiles;
            me.detailsDialog.form.xmqrsFiles = result.data.xmqrsFiles;

            me.detailsDialog.form.aaFiles = result.data.aaFiles;
            me.detailsDialog.form.bbFiles = result.data.bbFiles;
            me.detailsDialog.form.ccFiles = result.data.ccFiles;
            me.detailsDialog.form.ddFiles = result.data.ddFiles;
            me.detailsDialog.form.eeFiles = result.data.eeFiles;
            me.detailsDialog.form.ffFiles = result.data.ffFiles;
            me.detailsDialog.form.ggFiles = result.data.ggFiles;
            me.detailsDialog.form.hhFiles = result.data.hhFiles;
            me.detailsDialog.form.iiFiles = result.data.iiFiles;
            me.detailsDialog.form.jjFiles = result.data.jjFiles;
            me.detailsDialog.form.kkFiles = result.data.kkFiles;
            me.detailsDialog.form.llFiles = result.data.llFiles;
            me.detailsDialog.form.mmFiles = result.data.mmFiles;
            me.detailsDialog.form.nnFiles = result.data.nnFiles;
            me.detailsDialog.form.ooFiles = result.data.ooFiles;
            me.detailsDialog.form.ppFiles = result.data.ppFiles;
            me.detailsDialog.form.qqFiles = result.data.qqFiles;
            me.detailsDialog.form.rrFiles = result.data.rrFiles;
            me.detailsDialog.form.ssFiles = result.data.ssFiles;
            me.detailsDialog.form.ttFiles = result.data.ttFiles;

            me.detailsDialog.form.uuFiles = result.data.uuFiles;
            me.detailsDialog.form.vvFiles = result.data.vvFiles;
            me.detailsDialog.form.wwFiles = result.data.wwFiles;
            me.detailsDialog.form.xxFiles = result.data.xxFiles;
            me.detailsDialog.form.yyFiles = result.data.yyFiles;

            me.detailsDialog.form.zzFiles = result.data.zzFiles;
            me.detailsDialog.form.aaaFiles = result.data.aaaFiles;
            me.detailsDialog.form.abbFiles = result.data.abbFiles;
            me.detailsDialog.form.accFiles = result.data.accFiles;
            me.detailsDialog.form.addFiles = result.data.addFiles;

            me.detailsDialog.form.aeeFiles = result.data.aeeFiles;
            me.detailsDialog.form.affFiles = result.data.affFiles;
            me.detailsDialog.form.aggFiles = result.data.aggFiles;
            me.detailsDialog.form.ahhFiles = result.data.ahhFiles;
            me.detailsDialog.form.aiiFiles = result.data.aiiFiles;

          }
        }
      });
    },

    clearDetailsDialog(){
      this.detailsDialog={
        form: {
          id: '',
          agedId: '',
          agedName:'',
          idCard: '',
          agedPhone: '',
          location: '',
          agedFamilyId:'',
          agedFamilyName:'',
          servicePerson:'',
          woType: '',
          notices: '',
          serviceOffer: '',
          servicePersonId: '',
          name:'',
          serviceType: '',
          serviceCycle: '',
          planStartTime: '',
          planEndTime: '',
          workOrderContentId: '',
          serviceContent: '',
          woSource: '',
          unitPrice: '',
          priceMode: '',
          updateReason: '',
          workOrderContent:'',
          remarks:'',
          files:[],
          cFiles:[],
          wFiles:[],
          kFiles:[],
          qFiles:[],
          hFiles:[],
          qrsFiles:[],
          aaFiles:[],
          bbFiles:[],
          ccFiles:[],
          ddFiles:[],
          eeFiles:[],
          ffFiles:[],
          ggFiles:[],
          hhFiles:[],
          iiFiles:[],
          jjFiles:[],
          kkFiles:[],
          llFiles:[],
          mmFiles:[],
          nnFiles:[],
          ooFiles:[],
          ppFiles:[],
          qqFiles:[],
          rrFiles:[],
          ssFiles:[],
          ttFiles:[],

          uuFiles:[],
          vvFiles:[],
          wwFiles:[],
          xxFiles:[],
          yyFiles:[],
          zzFiles:[],
          aaaFiles:[],
          abbFiles:[],
          accFiles:[],
          addFiles:[],
          aeeFiles:[],
          affFiles:[],
          aggFiles:[],
          ahhFiles:[],
          aiiFiles:[],

          ajjFiles:[],
          akkFiles:[],
          allFiles:[],
          ammFiles:[],
          annFiles:[],
          aooFiles:[],
          appFiles:[],
          aqqFiles:[],
          examineCivil:'',
          examineProject:'',

          wangg:'',
          sos:'',
          hongw:'',
          menc:'',
          ranq:'',
          yang:'',
          shuij:'',
          fangh:'',
          hulic:'',
          chuangb:'',
          fus:'',
          muyuy:'',
          shouz:'',
          luny:'',
          zhuxq:'',
          chuangd:'',
          shexiangt:'',
          xiaoyed:'',
          shouhuan:'',
          gaocha:'',
        },
      }
    },

    copydata(){
      let me = this;
      me.datanew.id = me.detailsDialog.form.id;
      me.datanew.updateReason = me.detailsDialog.form.updateReason;
      me.datanew.wangg = me.detailsDialog.form.wangg;
      me.datanew.sos = me.detailsDialog.form.sos;
      me.datanew.hongw = me.detailsDialog.form.hongw;
      me.datanew.menc = me.detailsDialog.form.menc;
      me.datanew.ranq = me.detailsDialog.form.ranq;
      me.datanew.yang = me.detailsDialog.form.yang;
      me.datanew.shuij = me.detailsDialog.form.shuij;
      me.datanew.fangh = me.detailsDialog.form.fangh;
      me.datanew.hulic = me.detailsDialog.form.hulic;
      me.datanew.chuangb = me.detailsDialog.form.chuangb;
      me.datanew.fus = me.detailsDialog.form.fus;
      me.datanew.muyuy = me.detailsDialog.form.muyuy;
      me.datanew.shouz = me.detailsDialog.form.shouz;
      me.datanew.luny = me.detailsDialog.form.luny;
      me.datanew.zhuxq = me.detailsDialog.form.zhuxq;
      me.datanew.chuangd = me.detailsDialog.form.chuangd;
      me.datanew.shexiangt = me.detailsDialog.form.shexiangt;
      me.datanew.xiaoyed = me.detailsDialog.form.xiaoyed;
      me.datanew.shouhuan = me.detailsDialog.form.shouhuan;
      me.datanew.gaocha = me.detailsDialog.form.gaocha;
    },


    rowStyle({row, rowIndex}){
      if(!row.servicePerson){
        return {
          color:'red'
        };
      }
    },
    enumsFormatter(row, column, cellValue){
      if(this.enums && this.enums[column.property]){
        return this.enums[column.property][cellValue];
      }else {
        return cellValue;
      }
    },

    clearDataNew(){
      let me = this;
      me.AllData={
        wangg:'',
        sos:'',
        hongw:'',
        menc:'',
        ranq:'',
        yang:'',
        shuij:'',
        fangh:'',
        hulic:'',
        chuangb:'',
        fus:'',
        muyuy:'',
        shouz:'',
        luny:'',
        zhuxq:'',
        chuangd:'',
        shexiangt:'',
        xiaoyed:'',
        shouhuan:'',
        aller:'',
        gaocha:'',
      };
      me.DataDown=[];
      me.aoa = [];
    },

    //分页
    handleCurrentChange: function(val) {
      this.agedHealthTable.page.currentPage = val;
      this.getAgedTable();
    },



  }
}
</script>

<style scoped>

.header-data{
  height: 100%;
  width: 98.5%;
  padding: 10px;
  border-radius: 30px;
  margin-bottom: 20px;
}

.header-data-1{
  height: 100%;
  width: auto;
  padding: 5px;
  border-radius: 30px;
  margin-bottom: 10px;
}

.el-timeline-item{
  color: #2C70F7;
  margin-left: 0%
}

.icon-1{
  padding-left: 40px;
  padding-top: 20px;
}

.main-new {
  background: #FFFFFF;

  width: 1000px;
  height: 530px;
  margin-right:-53px;
  margin-left: -30px;

}
.main-new1 {
  background: #FFFFFF;

  width: 1000px;
  height: 55px;
  margin-left: -10px;

}
.card-1 {
  background-color: #EBF5FE;
  width: 100%;
  height: 220px;
  margin-right:20px;
  margin-bottom: 20px;
  border-radius: 15px;


}

</style>
